import { isEmpty } from 'lodash'
import { DEFAULT_PAYER_VA_SOFTPHONE_KEY, IPhonePreferences, IUserPhone, IUserPreference } from './settingsTypes'

export const parseJSON = (data: string): string | object => {
  try {
    return JSON.parse(data)
  } catch {
    return data
  }
}

export const parseUserPhoneData = (userPhoneData?: Record<string, never> | IUserPreference) => {
  const parsedPhoneData = parseJSON(userPhoneData?.value || '')
  let userPhone: IUserPhone | null = null
  if (!isEmpty(parsedPhoneData) && typeof parsedPhoneData === 'object') {
    const phonePreferences = parsedPhoneData as IPhonePreferences
    if (
      phonePreferences.currentSelection !== DEFAULT_PAYER_VA_SOFTPHONE_KEY &&
      phonePreferences.phones &&
      0 < phonePreferences.phones.length
    ) {
      userPhone = phonePreferences.phones.find((phone) => phonePreferences.currentSelection === phone.id) as IUserPhone
      return {
        userPhone,
        phonePreferences,
      }
    }
  }

  return {
    userPhone,
  }
}
